<div class="cm-landing-fixed-width cm-hero-section">
	<h1>
		Submission Successful
	</h1>
</div>

<div class="cm-landing-fixed-width cm-form">
	<p>
		Thank you for reaching out to CropManage.
	</p>
	<h2>What happens next:</h2>
	<ul>
		<li>
			Your inquiry has been logged and will be reviewed by a CropManage
			team member.
		</li>
		<li>
			If you need immediate guidance on using the platform, please
			refer to our <a href="https://help.cropmanage.ucanr.edu/">
				Tutorial
			</a>.
		</li>
	</ul>
	<button (click)="home()" class="cm-button--get-notified">
		Return to the Home Page
	</button>
</div>
